<template>
    <div class="page">
        
        <!-- 内容 -->
        <div class="container">
          <!-- 导航 -->
          <div v-if="!isPortrait" class="nav-bar">
            <div class="nav-title">
              <span style="cursor: pointer;" @click="handleBack" code-stm="event, PAGEURL, 返回起亚社区">起亚社区</span> > <span>详情页</span> 
            </div>
          </div>
          <div v-if="isPortrait" class="nav-bar-portrait">
            <img @click="handleBack" src="/assets/~/media/images/community/mob/button-back-detail.png" alt="" code-stm="event, PAGEURL, 返回起亚社区">
          </div>
          <div class="content-part">
            <div class="detail-part">
                <div v-if="detailInfo.type == 1" class="article-image">
                    <img :src="detailInfo.mainImg" alt="">
                </div>
                <!-- 作者信息 -->
                <div v-if="detailInfo.type == 2" class="card-info moment-info" :class="{ 'moment-info-portrait': isPortrait }">
                        <img class="info-avatar" :src="detailInfo.userProfileImg" alt="">
                        <div class="info-text">
                            <div class="info-name">{{ detailInfo.nickName }}</div>
                            <div class="info-time">{{ formatDate(detailInfo.createTime) }}</div>
                        </div>
                    </div>
                <div class="detail-container" :class="{ 'detail-container-portrait': isPortrait }">
                <!-- 白边框 -->
                    <div v-if="detailInfo.type == 1" class="article-title">{{ detailInfo.title }}</div>
                    <!-- 作者信息 -->
                    <div v-if="detailInfo.type == 1" class="card-info">
                        <img class="info-avatar" :src="detailInfo.userProfileImg" alt="">
                        <div class="info-text">
                            <div class="info-name">{{ detailInfo.nickName }}</div>
                            <div class="info-time">{{ formatDate(detailInfo.createTime) }}</div>
                        </div>
                    </div>
                    <!-- 内容 富文本 -->
                    <div class="article-content" v-html="detailInfo.content"></div>
                    <!-- 动态图 -->
                    <div v-if="detailInfo.type == 2" class="dynamic-image"> 
                        <img v-for="item in getCardImage(detailInfo)" :key="item" :src="item" alt="">
                    </div>
                    <!-- 点赞文章/动态 -->
                    <div class="card-footer card-footer-detail">
                        <div class="card-footer-item" style="cursor: auto;" @click="handleComment">
                            <img :src="preText + '/assets/~/media/images/community/icon-comments.png'" alt="">
                            <div>{{ detailInfo.discussCount || '评论' }}</div>
                        </div> 
                        <div
                          class="card-footer-item"
                          :class="{ 'is-loading': likeLoginLoadingArticle }"
                          @click="handleLike(detailInfo.id)"
                        >
                            <img :code-stm="'event, PAGEURL, 文章/动态' + (detailInfo.isLiked ? '取消点赞' : '点赞')"
                            :src="preText + (detailInfo.isLiked ? '/assets/~/media/images/community/icon-like-red.png' : '/assets/~/media/images/community/icon-like.png')" alt="">
                            <div :code-stm="'event, PAGEURL, 文章/动态' + (detailInfo.isLiked ? '取消点赞' : '点赞')">{{ detailInfo.likesCount || '点赞' }}</div>
                            <div v-if="likeLoginLoadingArticle" class="footer-loading-mask">
                              <span class="footer-spinner"></span>
                            </div>
                        </div>
                    </div>

                    <!-- pc 评论 文章/动态 -->
                    <div v-if="!isPortrait" class="comment-part">
                        <el-input class="moment-input" v-model="FirstComment.content" type="textarea" maxlength="50" show-word-limit placeholder="写下您的评论…" />
                    </div>
                    <div v-if="!isPortrait" class="submit-button-part submit-button-part-detail">
                        <img @click="handleFirstSubmitComment" code-stm="event, PAGEURL, 一级评论提交"
                        :src="preText + (FirstSubmitEnable ? '/assets/~/media/images/community/button-comment.png': '/assets/~/media/images/community/button-comment-disable.png')" alt="">
                    </div>

                </div>
                
                <!-- 评论总数 -->
                <div v-show="detailInfo.discussCount > 0" class="comment-total">共{{ detailInfo.discussCount }}条评论</div>
                
                <!-- list-part -->
                <div v-show="detailInfo.discussCount > 0" class="detail-container">
                    <div
                      class="comments"
                      v-for="item in recommendList"
                      :key="item.id"
                      :data-comment-id="item.id"
                    >
                        <div class="card-info moment-info">
                            <img class="info-avatar" :src="item.userAvatar" alt="">
                            <div class="info-text">
                                <div class="info-name">{{ item.userNickname }}</div>
                                <div class="info-time">{{ formatDate(item.createTime) }}</div>
                            </div>
                        </div>
                        <div class="comment-content first-comment-content">{{item.content}}</div>
                        <div class="card-footer">
                            <div class="card-footer-item" @click="toggleReplyBox(item.id)">
                                <div code-stm="event, PAGEURL, 点击回复评论">回复</div>
                            </div>
                            <div
                              class="card-footer-item first-comment-like"
                              :class="{ 'is-loading': !!likeLoginLoadingCommentMap[item.id] }"
                              @click="handleLikeComment(item.id)"
                            >
                                <img  :code-stm="'event, PAGEURL, 一级评论' + (item.isLiked ? '取消点赞' : '点赞')"
                                :src="preText + (item.isLiked ? '/assets/~/media/images/community/icon-like-red.png' : '/assets/~/media/images/community/icon-like.png')" alt="">
                                <div  :code-stm="'event, PAGEURL, 一级评论' + (item.isLiked ? '取消点赞' : '点赞')">{{ item.likesCount || '点赞' }}</div>
                                <div v-if="likeLoginLoadingCommentMap[item.id]" class="footer-loading-mask">
                                  <span class="footer-spinner"></span>
                                </div>
                            </div>
                        </div>
                        <!--  start 回复一级评论 框+提交按钮 pc -->
                        <div class="comment-reply-part" v-if="activeReplyCommentId === item.id && !isPortrait">
                            <div class="comment-reply">
                                <el-input class="moment-input" v-model="SecondComment.content" type="textarea" maxlength="50" show-word-limit :placeholder="getReplyPlaceholder(item)" />
                            </div>
                            <div class="submit-button-part">
                                <img @click="handleReplySubmitComment(item.id)" code-stm="event, PAGEURL, 二级评论提交"
                                :src="preText + (SecondSubmitEnable ? '/assets/~/media/images/community/button-reply.png': '/assets/~/media/images/community/button-reply-disable.png')" alt="">
                            </div>
                        </div>
                        <!--  end 回复一级评论 框+提交按钮 pc -->

                        <!-- 子评论列表 -->
                        <div
                          class="second-comment-list"
                          v-if="item.children && item.children.length"
                        >
                            <div
                              class="comment-item"
                              v-for="child in getVisibleChildren(item)"
                              :key="child.id"
                            >
                                <div class="card-info moment-info">
                                    <img class="info-avatar info-avatar-second" :src="child.userAvatar" alt="">
                                    <div class="info-text">
                                        <div class="info-name">{{ child.userNickname }}</div>
                                        <div class="info-time">{{ formatDate(child.createTime) }}</div>
                                    </div>
                                </div>
                                <div class="comment-content second-comment-content">{{child.content}}</div>
                                <div class="card-footer card-footer-second">
                                    <div
                                      class="card-footer-item"
                                      :class="{ 'is-loading': !!likeLoginLoadingCommentMap[child.id] }"
                                      @click="handleLikeComment(child.id, item.id)"
                                    >
                                        <img :code-stm="'event, PAGEURL, 二级评论' + (child.isLiked ? '取消点赞' : '点赞')"
                                        :src="preText + (child.isLiked ? '/assets/~/media/images/community/icon-like-red.png' : '/assets/~/media/images/community/icon-like.png')" alt="">
                                        <div :code-stm="'event, PAGEURL, 二级评论' + (child.isLiked ? '取消点赞' : '点赞')">{{ child.likesCount || '点赞' }}</div>
                                        <div v-if="likeLoginLoadingCommentMap[child.id]" class="footer-loading-mask">
                                          <span class="footer-spinner"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 加载更多 / 收起（二级评论） -->
                            <div
                              class="load-part load-part-second"
                              v-if="item.children && item.children.length > 1"
                            >
                                <!-- 加载中状态 -->
                                <div v-if="loadingSecondCommentId === item.id" class="load-ing">
                                    <div class="circle"></div>
                                    <img :src="preText + '/assets/~/media/images/community/loadcomments-ing.png'" alt="">
                                </div>
                                <!-- 显示“加载更多”：还有未展示的子评论 -->
                                <img
                                  v-else-if="showSecondLoadMore(item)"
                                  class="loadmore"
                                  @click="handleSecondLoadMore(item)"
                                  :src="preText + '/assets/~/media/images/community/loadcomments-more.png'"
                                  alt=""
                                >
                                <!-- 显示“收起”：已展示全部子评论 -->
                                <img
                                  v-else
                                  class="loadmore"
                                  @click="handleSecondPackUp(item)"
                                  :src="preText + '/assets/~/media/images/community/pack-up.png'"
                                  alt=""
                                >
                            </div>
                        </div>
                    </div> 
                </div>
                <!-- 一级评论：滑至列表底部附近自动加载更多 -->
                <div class="load-part load-part-first">
                    <div
                        v-show="showLoadMore"
                        ref="loadMoreSentinel"
                        class="load-more-sentinel"
                        aria-hidden="true"
                    />
                    <div v-show="isLoading" class="load-ing">
                        <div class="circle"></div>
                        <img :src="preText + '/assets/~/media/images/community/load-ing.png'" alt="">
                    </div>
                    <img
                        v-show="isAllLoaded && total > 0"
                        class="load-end"
                        :src="preText + '/assets/~/media/images/community/load-end.png'"
                        alt="">
                </div>
 
                <!-- mob 评论 -->
                <div
                  v-if="isMobileHeightMode"
                  class="mobile-comment-mask"
                  @click="handleMaskClick"
                ></div>
                <div v-if="isPortrait" class="mobile-comment-part"
                  :class="{
                    // 只有在移动端、Footer 进入视口 且 当前没有任意输入框 focus/回复态 时才隐藏
                    'mobile-comment-part--hide': isPortrait && isCommentAbsolute && !isFocus && !activeReplyCommentId
                  }"
                >
                    <!-- 回复态：只显示二级输入框 + 二级按钮 -->
                    <template v-if="activeReplyCommentId">
                      <el-input
                        ref="mobileSecondInput"
                        class="second-level-input height-level-input"
                        v-model="SecondComment.content"
                        type="textarea"
                        maxlength="50"
                        :placeholder="replyPlaceholder"
                        @blur="handleSecondBlur"
                      />
                      <div class="comment-submit second-level-submit">
                        <img
                          @mousedown="ignoreSecondBlur = true"
                          @touchstart="ignoreSecondBlur = true"
                          @click="handleReplySubmitComment(activeReplyCommentId)"
                          :src="preText + (SecondSubmitEnable ? '/assets/~/media/images/community/mob/button-send.png': '/assets/~/media/images/community/mob/button-send-disable.png')"
                          alt="" code-stm="event, PAGEURL, 二级评论提交"
                        >
                      </div>
                    </template>

                    <!-- 默认态：只显示一级输入框；focus 后变高并显示按钮，失焦还原为 short -->
                    <template v-else>
                      <el-input
                        ref="mobileFirstInput"
                        class="first-level-input"
                        :class="isFocus ? 'height-level-input' : 'short-level-input'"
                        v-model="FirstComment.content"
                        type="textarea"
                        maxlength="50"
                        placeholder="写下您的评论"
                        @focus="handleFirstFocus"
                        @blur="handleFirstBlur"
                      />
                      <div class="comment-submit first-level-submit" v-show="isFocus">
                        <img
                          @click="handleFirstSubmitComment"
                          :src="preText + (FirstSubmitEnable ? '/assets/~/media/images/community/mob/button-comment-small.png': '/assets/~/media/images/community/mob/button-comment-small-disable.png')"
                          alt=""
                          code-stm="event, PAGEURL, 一级评论提交"
                        >
                      </div>
                    </template>
                </div>

            </div>
            <div v-show="!isPortrait" class="advertise-part">
                <Advertise />
            </div>
          </div>
        </div>
        
        <!-- 提交结果弹窗 -->
        <Popup
          :visible="popupVisible"
          :title="popupInfo.title"
          :content="popupInfo.content"
          :button-text="popupInfo.button || popupInfo.type || '确定'"
          @close="closePopup"
          @confirm="handlePopupConfirm"
        />

        <!-- 评论提交全屏 loading（一级 / 二级共用） -->
        <div
          v-if="isSubmittingFirst || isSubmittingSecond"
          class="fullscreen-loading"
        >
          <div class="fullscreen-loading__spinner"></div>
          <div class="fullscreen-loading__text">提交中…</div>
        </div>
        <!-- 回复二级评论 全屏 loading（pc + mob） -->
        <div v-if="isCheckingLoginSecond" class="fullscreen-loading">
          <div class="fullscreen-loading__spinner"></div>
          <div class="fullscreen-loading__text">加载中…</div>
        </div>
    </div>
</template>

<script>
import { queUrl } from '@/config/base';
import Advertise from '@/components/community/advertise';
import Popup from '@/components/community/popup';
import { isPortraitFun} from "@/utils/utils.js";
import $ from 'jquery'
export default {
  name: 'Recommend',
  components: {
    Advertise,
    Popup
  },
  data() {
    return {
        isPortrait: isPortraitFun(),
        isCommentAbsolute: false, // 移动端：当 Footer 进入视口时改为 absolute，避免压住 Footer
        baseViewportHeight: 0, // 移动端初始视口高度，用于判断软键盘是否弹出
        FirstComment: {
            content: ''
        },
        SecondComment: {
            content: ''
        },
        isFocus: false, // 移动端一级评论是否聚焦
        replyPlaceholder: '写下您的评论…', // 移动端二级评论 placeholder
        mobileScrollBackupY: 0, // 软键盘弹出前的滚动位置（用于键盘收起后回滚）
        bodyStyleBackup: { position: '', top: '', overflow: '', width: '' }, // 锁 body 前的样式
        // 当前展开回复框的一级评论 ID（只允许一个）
        activeReplyCommentId: null,
        // 正在加载二级评论的一级评论 ID
        loadingSecondCommentId: null,
        popSuccessInfo: {
          title: '提交成功',
          content: '您编辑的内容已成功提交审核，感谢您的分享！',
          button: '我知道了',
        },
        popErrorInfo: {
          title: '内容审核不通过',
          content: '您提交内容中含有禁止内容，请修改后重新提交',
          type: '返回修改',
        },
        from: '',
        popupVisible: false,
        popupInfo: {},
        headers: {},
        preText:'https://www.kia.cn',
        recommendList: [],
        uploadImgUrl:  `${queUrl}interface/ossClient/upload`,
        pageNum: 1,
        pageSize: 10,
        total: 0,
        isLoading: false,
        noMore: false, // 后端不可靠返回 total 时，用于标记“没有更多”
        detailInfo: {},
        // 每个一级评论下当前可见的二级评论数量（key 为一级评论 id）
        secondVisibleCountMap: {},
        // 提交防抖：一级评论是否正在提交
        isSubmittingFirst: false,
        // 提交防抖：二级评论是否正在提交
        isSubmittingSecond: false,
        // 点赞前 checkLogin 的加载态
        likeLoginLoadingArticle: false,
        likeLoginLoadingCommentMap: {},
        // 移动端二级评论：点击发送时避免 blur 抢先收起
        ignoreSecondBlur: false,
        isCheckingLoginSecond: false,
        loadMoreObserver: null,
        /** 一级评论列表：触底后再上滑约多少像素才加载；与 recommend 一致，可改为 0 即贴底加载 */
        loadMoreExtraScrollPx: 0,
    }
  },
  computed: {
    //一级评论提交按钮是否可用
    FirstSubmitEnable() {
      const hasContent = this.FirstComment.content && this.FirstComment.content.trim().length > 0;
      return hasContent;
    },
    //二级评论提交按钮是否可用
    SecondSubmitEnable() {
      const hasContent = this.SecondComment.content && this.SecondComment.content.trim().length > 0;
      return hasContent;
    },
    isAllLoaded() {
      const reachedTotal = this.total > 0 && this.recommendList.length >= this.total;
      return reachedTotal || this.noMore;
    },
    showLoadMore() {
      return !this.isLoading && !this.isAllLoaded;
    },
    // 移动端：一级 height（isFocus）或二级回复态（activeReplyCommentId）时，视为“输入展开态”
    isMobileHeightMode() {
      return this.isPortrait && (this.isFocus || !!this.activeReplyCommentId);
    }
  },
  watch: {
    '$route.query.id'(nextId, prevId) {
      if (!nextId || nextId === prevId) return;
      // 切换到另一个详情时，始终从顶部开始
      this.scrollToTop();
    },
    // 输入展开态时，使用 preventDefault 锁定页面滚动（避免软键盘弹出后页面被拖动滚动）
    isMobileHeightMode(val) {
      if (val) {
        this.lockScrollByPreventDefault();
      } else {
        this.unlockScrollByPreventDefault();
      }
    }
  },
  activated() {
    // 从登录页返回/页面重新激活时刷新 Token、环境域名
    this.refreshRuntime();
    // 详情页进入时强制从顶部开始
    this.scrollToTop();
  },
  mounted() {
    // 初始化 headers、环境域名
    this.refreshRuntime();
    // 详情页进入时强制从顶部开始（避免复用/恢复导致的非顶部位置）
    this.scrollToTop();
    // 覆盖从登录页 history.back() 返回（bfcache 恢复）场景：mounted 不会再触发
    window.addEventListener('pageshow', this.handlePageShow);
    // 登录后从本地恢复未提交的内容
    try {
      const draftContent = localStorage.getItem('first_comment_content');
      if (draftContent) {
        this.FirstComment.content = draftContent;
        localStorage.removeItem('first_comment_content');
      }
    } catch (e) {
      // ignore restore error
    }
    
    this.getDetail(this.$route.query.id);
    this.getCommentsList(true);

    // 移动端：监听页面滚动，在 Footer 进入视口时将评论框由 fixed 变为 absolute，避免压住 Footer
    if (this.isPortrait) {
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      this.$nextTick(() => {
        this.handleScroll();
      });
    }
    this.$nextTick(() => {
      this.setupLoadMoreObserver();
    });
  },
  beforeDestroy() {
    this.teardownLoadMoreObserver();
    if (this.isPortrait) {
      window.removeEventListener('scroll', this.handleScroll);
    }
    window.removeEventListener('pageshow', this.handlePageShow);
    this.unlockScrollByPreventDefault();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.from = from.name
    })
  },
  methods: {
    scrollToTop() {
      try {
        this.$nextTick(() => {
          try {
            // 先用 rAF 等一帧，避免与路由 scrollBehavior / DOM 重排打架
            requestAnimationFrame(() => {
              try {
                window.scrollTo(0, 0);
              } catch (e) {
                // ignore
              }
            });
          } catch (e) {
            // requestAnimationFrame 不可用时直接滚动
            try {
              window.scrollTo(0, 0);
            } catch (err) {
              // ignore
            }
          }
        });
      } catch (e) {
        // ignore
      }
    },
    handlePageShow() {
      // pageshow 会在 bfcache 恢复时触发：刷新 Token、环境域名
      this.refreshRuntime();
    },
    refreshRuntime() {
      this.headers = { Token: this.getToken() };
      if (typeof window !== 'undefined') {
        this.preText = window.location.href.includes('https://www.kia.cn')
          ? 'https://www.kia.cn'
          : 'https://uat.kia.cn';
      }
    },
    handleBack() {
      const from = this.from
      if (from === 'recommend') {
        this.$router.back()
      } else {
        this.$router.push('/recommend')
      }
    },
    // 移动端滚动锁：通过 touchmove preventDefault（需要 passive:false）
    handleLockTouchMove(e) {
      try {
        if (!e || !e.target) {
          if (e && typeof e.preventDefault === 'function') e.preventDefault();
          return;
        }
        
        // 检查触摸点是否在 mobile-comment-part 内部
        const bar = this.$el && this.$el.querySelector
          ? this.$el.querySelector('.mobile-comment-part')
          : null;
        
        if (bar && bar.contains(e.target)) {
          // 在 mobile-comment-part 内部
          // 检查是否是 textarea 元素（允许 textarea 内部滚动）
          const isTextarea = e.target.tagName === 'TEXTAREA' || 
                            (e.target.closest && e.target.closest('textarea'));
          
          if (isTextarea) {
            // 在 textarea 内部：检查是否可以滚动（内容超出）
            const textarea = e.target.tagName === 'TEXTAREA' 
              ? e.target 
              : (e.target.closest ? e.target.closest('textarea') : null);
            
            if (textarea) {
              const canScroll = textarea.scrollHeight > textarea.clientHeight;
              if (canScroll) {
                // textarea 内容可以滚动，允许滚动（不阻止）
                return;
              }
            }
          }
          // 在 mobile-comment-part 内部但不是可滚动的 textarea，阻止页面滚动
          if (e && typeof e.preventDefault === 'function') e.preventDefault();
          return;
        }
        
        // 在 mobile-comment-part 外部，阻止页面滚动
        if (e && typeof e.preventDefault === 'function') e.preventDefault();
      } catch (err) {
        // 出错时也阻止，确保安全
        if (e && typeof e.preventDefault === 'function') e.preventDefault();
      }
    },
    lockScrollByPreventDefault() {
      if (!this.isPortrait) return;
      if (this._scrollLocked) return;
      this._scrollLocked = true;
      // 锁 body，防止键盘顶起后页面位移，解除时回滚
      this.lockBodyFixed();
      try {
        document.addEventListener('touchmove', this.handleLockTouchMove, { passive: false });
      } catch (e) {
        // ignore
      }
    },
    unlockScrollByPreventDefault() {
      if (!this._scrollLocked) return;
      this._scrollLocked = false;
      // 解锁 body，防止键盘顶起后页面位移，解除时回滚
      this.unlockBodyFixed();
      try {
        document.removeEventListener('touchmove', this.handleLockTouchMove, { passive: false });
      } catch (e) {
        // ignore
      }
    },
    // 锁 body，防止键盘顶起后页面位移，解除时回滚
    lockBodyFixed() {
      try {
        const body = document && document.body;
        if (!body) return;
        // 记录滚动位置与原样式
        const scrollY =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          0;
        this.mobileScrollBackupY = scrollY;
        this.bodyStyleBackup = {
          position: body.style.position || '',
          top: body.style.top || '',
          overflow: body.style.overflow || '',
          width: body.style.width || '',
        };
        body.style.position = 'fixed';
        body.style.top = `-${scrollY}px`;
        body.style.width = '100%';
        body.style.overflow = 'hidden';
        this._bodyFixedLocked = true;
      } catch (e) {
        // ignore
      }
    },
    // 解锁 body，防止键盘顶起后页面位移，解除时回滚
    unlockBodyFixed() {
      if (!this._bodyFixedLocked) return;
      try {
        const body = document && document.body;
        if (!body) return;
        const y = Number(this.mobileScrollBackupY) || 0;
        body.style.position = this.bodyStyleBackup.position || '';
        body.style.top = this.bodyStyleBackup.top || '';
        body.style.overflow = this.bodyStyleBackup.overflow || '';
        body.style.width = this.bodyStyleBackup.width || '';
        this._bodyFixedLocked = false;
        this.$nextTick(() => {
          try {
            window.scrollTo(0, y);
          } catch (e) {
            // ignore
          }
        });
      } catch (e) {
        // ignore
      }
    },
    //获取详情
    getDetail(id) {
      this.$axios
        .get(`${queUrl}api/community/client/detail?id=${id}`, {
          headers: this.headers
        })
        .then((res) => {
          if(res.data.code == 200) {
            this.detailInfo = res.data.data;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    //start二级评论显示逻辑：默认显示第一条，点击“加载更多”：一次性多展示 10 条，点击“收起”：只保留第一条子评论
    // 获取某个一级评论当前应展示的二级评论数量（默认 1 条）
    getSecondVisibleCount(commentId, totalChildren) {
      if (!commentId || !totalChildren) return 0;
      let count = this.secondVisibleCountMap[commentId];
      if (!count) {
        // 默认显示第一条
        count = 1;
        this.$set(this.secondVisibleCountMap, commentId, count);
      }
      // 不超过实际子评论数量
      return Math.min(count, totalChildren);
    },
    // 返回当前应展示的子评论列表
    getVisibleChildren(item) {
      const children = Array.isArray(item.children) ? item.children : [];
      if (!children.length) return [];
      const count = this.getSecondVisibleCount(item.id, children.length);
      return children.slice(0, count);
    },
    // 是否需要显示“加载更多”（还有未展示的子评论）
    showSecondLoadMore(item) {
      const children = Array.isArray(item.children) ? item.children : [];
      if (children.length <= 1) return false;
      const count = this.getSecondVisibleCount(item.id, children.length);
      return count < children.length;
    },
    // 点击“加载更多”：一次性多展示 10 条
    handleSecondLoadMore(item) {
      // 二级评论-加载更多埋点
      const stm = window && window.stm_clicki;
      if (typeof stm === 'function') {
        stm('send', 'event', window.location.href, '点击', '加载更多二级评论');
      }

      const children = Array.isArray(item.children) ? item.children : [];
      if (!item || !item.id || !children.length) return;
      if (this.loadingSecondCommentId === item.id) return; // 防止重复点击

      // 设置加载状态
      this.loadingSecondCommentId = item.id;

      // 模拟加载过程（因为这是本地分页，不是真正的接口请求）
      setTimeout(() => {
        const current = this.getSecondVisibleCount(item.id, children.length);
        const next = Math.min(current + 10, children.length);
        this.$set(this.secondVisibleCountMap, item.id, next);
        
        // 清除加载状态
        this.loadingSecondCommentId = null;

        // start 保持视口锚定到当前这条一级评论，避免感觉页面“往上长”
        // this.$nextTick(() => {
        //   try {
        //     const rootEl = this.$el;
        //     const selector = `.comments[data-comment-id="${item.id}"]`;
        //     const commentEl =
        //       rootEl && rootEl.querySelector
        //         ? rootEl.querySelector(selector)
        //         : null;
        //     if (commentEl && typeof commentEl.scrollIntoView === 'function') {
        //       commentEl.scrollIntoView({ behavior: 'auto', block: 'start' });
        //     }
        //   } catch (e) {
        //     // ignore scroll error
        //   }
        // });
        // end 保持视口锚定到当前这条一级评论，避免感觉页面“往上长”
      }, 300); // 300ms 的加载动画时间
    },
    // 点击“收起”：只保留第一条子评论
    handleSecondPackUp(item) {
      // 二级评论-收起埋点
      const stm = window && window.stm_clicki;
      if (typeof stm === 'function') {
        stm('send', 'event', window.location.href, '点击', '收起二级评论');
      }
      
      if (!item || !item.id) return;
      if (!item.children || !item.children.length) return;
      this.$set(this.secondVisibleCountMap, item.id, 1);
      // start 同样在收起后锚定到该一级评论位置，减轻页面跳动感
      this.$nextTick(() => {
        try {
          const rootEl = this.$el;
          const selector = `.comments[data-comment-id="${item.id}"]`;
          const commentEl =
            rootEl && rootEl.querySelector
              ? rootEl.querySelector(selector)
              : null;
          if (commentEl && typeof commentEl.scrollIntoView === 'function') {
            commentEl.scrollIntoView({ behavior: 'auto', block: 'start' });
          }
        } catch (e) {
          // ignore scroll error
        }
      });
      //end 同样在收起后锚定到该一级评论位置，减轻页面跳动感
    },
    //end二级评论显示逻辑

    handleFirstFocus() {
      this.isFocus = true;
    },
    handleFirstBlur() {
      // 失去焦点后，无论是否有内容，都还原为 short-level-input，按钮隐藏
      // 这里用异步延迟，避免在点击“发送”按钮时先触发 blur，把按钮（v-show）和遮罩一起收起，
      setTimeout(() => {
        this.isFocus = false;
      }, 100);
    },
    handleSecondBlur() {
      // 二级输入框失焦：收起回复态，回到一级 short-level-input
      if (!this.isPortrait) return;
      if (this.ignoreSecondBlur) {
        // 点击“发送”按钮时会先触发 blur，这里放行 click
        setTimeout(() => {
          this.ignoreSecondBlur = false;
        }, 0);
        return;
      }
      // 延迟收起，避免移动端点击按钮时 blur 抢先触发导致 click 丢失
      setTimeout(() => {
        if (this.ignoreSecondBlur) return;
        this.activeReplyCommentId = null;
        this.replyPlaceholder = '写下您的评论…';
      }, 100);
    },
    handleMaskClick() {
      // 点击遮罩：收起所有输入态
      this.isFocus = false;
      if (this.activeReplyCommentId) {
        this.activeReplyCommentId = null;
        this.SecondComment.content = '';
        this.replyPlaceholder = '写下您的评论…';
      }
    },
    // 获取回复框的 placeholder
    getReplyPlaceholder(item) {
      if (!item || !item.userNickname) {
        return '写下您的评论…';
      }
      return `回复@${item.userNickname}`;
    },
    handleComment() {//点击评论
      if (this.isPortrait) {
        //展开一级评论框
        this.isFocus = true;
        //自动聚焦一级评论框
        this.$nextTick(() => {
          try {
            debugger
            const input = this.$refs.mobileFirstInput;
            if (input && typeof input.focus === 'function') {
              input.focus();
            }
          } catch (e) {
            // ignore focus error
          }
        });
      }
    },
    // 展开/收起某个一级评论的回复框（全局只保留一个）
    async toggleReplyBox(commentId) {
      
      if (!commentId) return;
      if (this.activeReplyCommentId === commentId) {
        // 再次点击同一条，收起
        this.activeReplyCommentId = null;
        this.SecondComment.content = '';
        this.replyPlaceholder = '写下您的评论…';
      } else {
        this.isCheckingLoginSecond = true;
        const ok = await this.checkLogin();
        this.isCheckingLoginSecond = false;
        if (!ok) return;
        // 切换到新的评论，收起旧的，只展开当前
        this.activeReplyCommentId = commentId;
        this.SecondComment.content = '';
        // 为移动端二级输入框设置 placeholder
        try {
          const list = Array.isArray(this.recommendList) ? this.recommendList : [];
          const target = list.find(c => c && c.id === commentId) || null;
          this.replyPlaceholder = this.getReplyPlaceholder(target);
        } catch (e) {
          this.replyPlaceholder = '写下您的评论…';
        }
        // 移动端：展开回复时自动聚焦二级输入框
        if (this.isPortrait) {
          this.$nextTick(() => {
            try {
              const input = this.$refs.mobileSecondInput;
              if (input && typeof input.focus === 'function') {
                input.focus();
              }
            } catch (e) {
              // ignore focus error
            }
          });
        }
      }
    },
    //提交一级评论
    async handleFirstSubmitComment() {
        if (!this.FirstSubmitEnable) {
          // 没有内容时不提交，同时恢复状态
          this.isSubmittingFirst = false;
          return;
        }
        // 防抖：提交中直接忽略后续点击
        if (this.isSubmittingFirst) return;
        // 一进来先标记，防止在 checkLogin 异步期间被多次点击
        this.isSubmittingFirst = true;

        const ok = await this.checkLogin();
        if (!ok) {
          // 未登录 / token 过期时直接恢复状态
          this.isSubmittingFirst = false;
          return;
        }

        var that = this;
        var submitData = {
          content: that.FirstComment.content,
          sourceId: that.detailInfo.id,
        }

      

      this.$axios
        .post(`${queUrl}interface/community/client/discussion/save`, submitData, {
          headers: that.headers
        })
        .then((res) => {
          if(res.data.code == 200) {
            this.openPopup(this.popSuccessInfo);
            // 发布成功后，清空表单
            that.FirstComment.content = '';
            that.isFocus = false;
          } else {
            if(res.data.msg == '文本检测违规' || res.data.msg == '图片检测违规'){
              this.openPopup(this.popErrorInfo);
            }else{
              this.$message.error(res.data.message);
            }
          }
        })
        .catch((err) => {
          if (err && err.response && err.response.data && err.response.data.message) {
            this.$message.error(err.response.data.message);
          }
        })
        .finally(() => {
          this.isSubmittingFirst = false;
        });
    },
    //提交二级评论
    handleReplySubmitComment(commentId) {
        // 防抖：提交中直接忽略后续点击
        if (this.isSubmittingSecond) return;
        // 允许后续 blur 正常收起
        this.ignoreSecondBlur = false;
        var that = this;
        var submitData = {
            content: that.SecondComment.content,
            parentid: commentId,
            sourceId: that.detailInfo.id,
        }
        if (this.SecondSubmitEnable) {
            this.isSubmittingSecond = true;
            this.$axios
            .post(`${queUrl}interface/community/client/discussion/save`, submitData, {
                headers: this.headers
            })
        
            .then((res) => {
                if(res.data.code == 200) {
                    this.openPopup(this.popSuccessInfo);
                    // 发布成功后，清空表单
                    that.SecondComment.content = '';
                    // 收起回复框
                    that.activeReplyCommentId = null;
                    that.replyPlaceholder = '写下您的评论…';
                } else {
                    if(res.data.msg == '文本检测违规' || res.data.msg == '图片检测违规'){
                        this.openPopup(this.popErrorInfo);
                    }else{
                        this.$message.error(res.data.message);
                    }
                }
                this.isSubmittingSecond = false;
            })
            .catch((err) => {
            this.isSubmittingSecond = false;
            this.$message.error(err.response && err.response.data && err.response.data.message ? err.response.data.message : '提交失败，请稍后重试');
            })
        }
    },
    openPopup(info) {
      this.popupInfo = info || {};
      this.popupVisible = true;
    },
    closePopup() {
      this.popupVisible = false;
    },
    handlePopupConfirm() {
      this.closePopup();
    },
    
    // checkLogin() {
    //     //判断是否登录
    //     var getUserInfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
    //     var isLogin = getUserInfo && getUserInfo.token !=="" ? true : false;
    //     if (!isLogin) {//未登录
    //         // 跳转前先保存当前未提交内容，登录回来后恢复
    //         try {
    //             if (this.FirstComment && typeof this.FirstComment.content === 'string') {
    //                 localStorage.setItem('first_comment_content', this.FirstComment.content);
    //             }
    //         } catch (e) {
    //             // ignore save error
    //         }
    //         window.parent.location.href = this.preText + '/user-management/login?community=recommend';
    //         // window.parent.location.href = 'http://192.168.1.148:5173/user-management/login?community=recommend';//本地测试
    //         return false; // 返回 false 表示未登录
    //     }
    //     return true; // 返回 true 表示已登录
    // },
    checkLogin() {
      // 判断是否登录（本地有 user 且 token 不为空）
      const getUserInfo = localStorage.getItem('user')
        ? JSON.parse(localStorage.getItem('user'))
        : null;
      const isLogin = !!(getUserInfo && getUserInfo.token);

      if (!isLogin) { // 未登录
        console.log('未登录');
        // 跳转前先保存当前未提交内容，登录回来后恢复
        if (this.FirstComment && typeof this.FirstComment.content === 'string') {
          localStorage.setItem('first_comment_content', this.FirstComment.content);
        }
        //跳转登录页面
        window.parent.location.href = this.preText + '/user-management/login?detailId=' + this.$route.query.id;
        // window.parent.location.href = 'http://192.168.1.148:5173/user-management/login?community/recommend';//本地测试
        return Promise.resolve(false); // 未登录：直接返回 false
      }

      // 已登录，进一步判断 token 是否过期（异步接口）
      let aURL = '';
      if (window.location.href.includes('www.kia.cn')) {
        aURL = 'https://kiacarservice.kia.cn/kia-carservice-api';
      } else if (window.location.href.includes('uat.kia.cn')) {
        aURL = 'https://kiacarservice-uat.kia.cn/kia-carservice-api';
      } else {
        aURL = 'http://kiatest.runlin.cn/kia-carservice-api';
      }

      const token = getUserInfo.token;
      const userId = getUserInfo.userId;

      var that = this;
      // 返回 Promise<boolean>：true 表示 token 有效，false 表示已过期
      return new Promise((resolve) => {
        $.ajax({
          url: aURL + '/user/info',
          type: 'get',
          dataType: 'json',
          data: { userId },
          beforeSend: (xhr) => {
            xhr.setRequestHeader('Token', token);
          },
          success: (res) => {
            if (res.code === 0 && res.data) {
              // token 未过期
              console.log('token 未过期');
              resolve(true);
            } else {
              // 过期：清除本地 user
              console.log('token 过期');
              // 跳转前先保存当前未提交内容，登录回来后恢复
              if (that.FirstComment && typeof that.FirstComment.content === 'string') {
                localStorage.setItem('first_comment_content', that.FirstComment.content);
              }
              localStorage.removeItem('user');
              window.parent.location.href = that.preText + '/user-management/login?community=recommend';
              resolve(false);
            }
          },
          error: (err) => {
            // 接口异常也视为过期
            if (err && err.status === 401) {
              console.log('异常');
              // 跳转前先保存当前未提交内容，登录回来后恢复
              if (that.FirstComment && typeof that.FirstComment.content === 'string') {
                localStorage.setItem('first_comment_content', that.FirstComment.content);
              }
              localStorage.removeItem('user');
              window.parent.location.href = that.preText + '/user-management/login?community=recommend';
            }
            resolve(false);
          },
        });
      });
    },
    getToken() {
        var getUserInfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
        if (!getUserInfo) {
            return '';
        }
        return getUserInfo.token || '';
    },
    //获取评论列表
    getCommentsList(isReset = false) {
      if (this.isLoading) return;
      if (!isReset && this.isAllLoaded) return;

      if (isReset) {
        this.pageNum = 1;
        this.total = 0;
        this.noMore = false;
        this.recommendList = [];
        this.secondVisibleCountMap = {};
      }

      this.isLoading = true;
      this.$axios
        .get(`${queUrl}api/community/client/getDiscussionTreeList`, {
          params: {
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            sourceId: this.$route.query.id
          },
          headers: this.headers
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.total = res.data.total || 0;
            const rows = Array.isArray(res.data.rows) ? res.data.rows : [];

            // 追加数据时去重（按 id），避免后端总返回前几条导致重复叠加
            const existingIds = new Set(this.recommendList.map(item => item.id));
            const newRows = isReset
              ? rows
              : rows.filter(item => !existingIds.has(item.id));

            this.recommendList = isReset ? rows : this.recommendList.concat(newRows);

            // 如果返回条数小于 pageSize，说明已经是最后一页
            if (rows.length < this.pageSize || rows.length === 0) {
              this.noMore = true;
            }

            // 只有在接口真的返回数据时才翻到下一页
            if (rows.length > 0) this.pageNum += 1;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false;
        });
    },
    // 一级评论列表触底加载（IntersectionObserver / scroll 降级）
    handleLoadMore() {
      this.getCommentsList(false);
    },
    setupLoadMoreObserver() {
      this.teardownLoadMoreObserver();
      if (typeof IntersectionObserver === 'undefined') {
        this._scrollLoadMoreHandler = () => {
          if (this.isLoading || this.isAllLoaded || !this.showLoadMore) return;
          const el = this.$refs.loadMoreSentinel;
          if (!el || typeof el.getBoundingClientRect !== 'function') return;
          const top = el.getBoundingClientRect().top;
          const line = window.innerHeight - this.loadMoreExtraScrollPx;
          if (top < line) {
            this.handleLoadMore();
          }
        };
        window.addEventListener('scroll', this._scrollLoadMoreHandler, { passive: true });
        return;
      }
      this.$nextTick(() => {
        const el = this.$refs.loadMoreSentinel;
        if (!el) return;
        const past = Math.max(0, Number(this.loadMoreExtraScrollPx) || 0);
        this.loadMoreObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            if (!entry || !entry.isIntersecting) return;
            if (this.isLoading || this.isAllLoaded) return;
            this.handleLoadMore();
          },
          {
            root: null,
            rootMargin: `0px 0px -${past}px 0px`,
            threshold: 0,
          }
        );
        this.loadMoreObserver.observe(el);
      });
    },
    teardownLoadMoreObserver() {
      if (this.loadMoreObserver) {
        this.loadMoreObserver.disconnect();
        this.loadMoreObserver = null;
      }
      if (this._scrollLoadMoreHandler) {
        window.removeEventListener('scroll', this._scrollLoadMoreHandler);
        this._scrollLoadMoreHandler = null;
      }
    },
    //格式化日期
    formatDate(dateTimeStr) {
      // input: YYYY-MM-DD HH:mm:ss -> output: YYYY-MM-DD
      // if (!dateTimeStr) return '';
      // if (typeof dateTimeStr !== 'string') return '';
      // return dateTimeStr.split(' ')[0];
      return dateTimeStr;
    },
    
    //获取卡片图片
    getCardImage(item) {
        if (!item) return '';
        const listStr = item.imgList;
        const list = listStr.split(',')
        return list || [];
    },
    
    // 本地点赞记录（localStorage）
    getLocalLikedIds() {
      try {
        const raw = localStorage.getItem('community_liked_article_ids');
        const arr = raw ? JSON.parse(raw) : [];
        return Array.isArray(arr) ? arr : [];
      } catch (e) {
        return [];
      }
    },
    setLocalLikedIds(ids) {
      localStorage.setItem('community_liked_article_ids', JSON.stringify(ids || []));
    },
    isLocallyLiked(id) {
      if (id === undefined || id === null) return false;
      return this.getLocalLikedIds().includes(id);
    },
    addLocalLike(id) {
      const ids = this.getLocalLikedIds();
      if (!ids.includes(id)) {
        ids.push(id);
        this.setLocalLikedIds(ids);
      }
    },
    removeLocalLike(id) {
      const ids = this.getLocalLikedIds().filter(x => x !== id);
      this.setLocalLikedIds(ids);
    },
    //点赞 文章动态
    async handleLike(id) {
      if (id === undefined || id === null) return;
      if (this.likeLoginLoadingArticle) return;
      this.likeLoginLoadingArticle = true;
      const ok = await this.checkLogin();
      this.likeLoginLoadingArticle = false;
      if (!ok) return;
      if (!this.detailInfo || this.detailInfo.id !== id) return;

      const alreadyLiked = this.detailInfo.isLiked || this.isLocallyLiked(id);
      const prevLiked = !!this.detailInfo.isLiked;
      const prevCount = Number(this.detailInfo.likesCount) || 0;

      if (alreadyLiked) {
        // 取消点赞：本地 -1，并移除本地记录
        this.detailInfo.isLiked = false;
        this.detailInfo.likesCount = Math.max(prevCount - 1, 0);
        this.removeLocalLike(id);

        this.$axios
          .post(
            `${queUrl}interface/community/client/likeArticle?articleId=${id}`,
            {},
            { headers: this.headers }
          )
          .then((res) => {
            if (res.data.code == 200) {
              // 成功：保持取消后的状态
              return;
            }
            // 失败：回滚为已点赞
            this.detailInfo.isLiked = true;
            this.detailInfo.likesCount = prevCount;
            this.addLocalLike(id);
            this.$message.error(res.data.message);
          })
          .catch(() => {
            this.detailInfo.isLiked = true;
            this.detailInfo.likesCount = prevCount;
            this.addLocalLike(id);
          });
      } else {
        // 点赞：本地 +1，并记录本地已点赞
        this.detailInfo.isLiked = true;
        this.detailInfo.likesCount = prevCount + 1;
        this.addLocalLike(id);

        this.$axios
          .post(
            `${queUrl}interface/community/client/likeArticle?articleId=${id}`,
            {},
            { headers: this.headers }
          )
          .then((res) => {
            if (res.data.code == 200) {
              // 成功：保持已点赞状态
              return;
            }
            // 失败：回滚
            this.detailInfo.isLiked = prevLiked;
            this.detailInfo.likesCount = prevCount;
            this.removeLocalLike(id);
            this.$message.error(res.data.message);
          })
          .catch(() => {
            this.detailInfo.isLiked = prevLiked;
            this.detailInfo.likesCount = prevCount;
            this.removeLocalLike(id);
          });
      }
    },
    // 本地点赞评论记录（localStorage，使用不同的key区分评论和文章）
    getLocalLikedCommentIds() {
      try {
        const raw = localStorage.getItem('community_liked_comment_ids');
        const arr = raw ? JSON.parse(raw) : [];
        return Array.isArray(arr) ? arr : [];
      } catch (e) {
        return [];
      }
    },
    setLocalLikedCommentIds(ids) {
      localStorage.setItem('community_liked_comment_ids', JSON.stringify(ids || []));
    },
    isLocallyLikedComment(id) {
      if (id === undefined || id === null) return false;
      return this.getLocalLikedCommentIds().includes(id);
    },
    addLocalLikeComment(id) {
      const ids = this.getLocalLikedCommentIds();
      if (!ids.includes(id)) {
        ids.push(id);
        this.setLocalLikedCommentIds(ids);
      }
    },
    removeLocalLikeComment(id) {
      const ids = this.getLocalLikedCommentIds().filter(x => x !== id);
      this.setLocalLikedCommentIds(ids);
    },
    // 查找评论（包括一级评论和子评论）
    findComment(commentId, parentId = null) {
      if (!commentId) return null;
      for (const item of this.recommendList) {
        if (item.id === commentId) {
          return item;
        }
        // 查找子评论
        if (item.children && Array.isArray(item.children)) {
          const child = item.children.find(c => c.id === commentId);
          if (child) return child;
        }
      }
      return null;
    },
    //点赞评论
    async handleLikeComment(id, parentId = null) {
      if (id === undefined || id === null) return;
      if (this.likeLoginLoadingCommentMap[id]) return;
      this.$set(this.likeLoginLoadingCommentMap, id, true);
      const ok = await this.checkLogin();
      this.$delete(this.likeLoginLoadingCommentMap, id);
      if (!ok) return;
      const comment = this.findComment(id, parentId);
      if (!comment) return;

      const alreadyLiked = comment.isLiked || this.isLocallyLikedComment(id);
      const prevLiked = !!comment.isLiked;
      const prevCount = Number(comment.likesCount) || 0;

      if (alreadyLiked) {
        // 取消点赞：本地 -1，并移除本地记录
        comment.isLiked = false;
        comment.likesCount = Math.max(prevCount - 1, 0);
        this.removeLocalLikeComment(id);

        this.$axios.get(
          `${queUrl}interface/community/client/discussion/like`, 
          {
            params: {
              discussionId: id
            },
            headers: this.headers
          }
        )
        .then((res) => {
          if (res.data.code == 200) {
            // 成功：保持取消后的状态
            return;
          }
          // 失败：回滚为已点赞
          comment.isLiked = true;
          comment.likesCount = prevCount;
          this.addLocalLikeComment(id);
          this.$message.error(res.data.message);
        })
        .catch(() => {
          comment.isLiked = true;
          comment.likesCount = prevCount;
          this.addLocalLikeComment(id);
        });
      } else {
        // 点赞：本地 +1，并记录本地已点赞
        comment.isLiked = true;
        comment.likesCount = prevCount + 1;
        this.addLocalLikeComment(id);

        this.$axios.get(
          `${queUrl}interface/community/client/discussion/like`, 
          {
            params: {
              discussionId: id
            },
            headers: this.headers
          }
        )
        .then((res) => {
          if (res.data.code == 200) {
            // 成功：保持已点赞状态
            return;
          }
          // 失败：回滚
          comment.isLiked = prevLiked;
          comment.likesCount = prevCount;
          this.removeLocalLikeComment(id);
          this.$message.error(res.data.message);
        })
        .catch(() => {
          comment.isLiked = prevLiked;
          comment.likesCount = prevCount;
          this.removeLocalLikeComment(id);
        });
      }
    },
    // 监听页面滚动：当全局 Footer 进入视口时，移动端评论框由 fixed 变为 absolute，避免压住 Footer
    handleScroll() {
      if (!this.isPortrait) return;
      try {
        const currentViewportHeight =
          window.innerHeight || document.documentElement.clientHeight || 0;
        if (!this.baseViewportHeight) {
          this.baseViewportHeight = currentViewportHeight;
        }
        const heightDiff = this.baseViewportHeight - currentViewportHeight;
        const isKeyboardOpen = heightDiff > 80; // 经验值：高度缩小超过 80 像素视为键盘弹出
        // 直接通过 DOM 查询全局 Footer 容器（App.vue 中的 id="page1"）
        const footer = document.getElementById('page1');
        if (!footer || typeof footer.getBoundingClientRect !== 'function') {
          this.isCommentAbsolute = false;
          return;
        }
        const rect = footer.getBoundingClientRect();
        const viewportHeight = currentViewportHeight;
        // 当 Footer 顶部进入视口时，评论框改为 absolute；否则保持 fixed 吸底
        // 但在软键盘弹出时，不改为 absolute，避免输入框被隐藏
        this.isCommentAbsolute = !isKeyboardOpen && rect.top <= viewportHeight;
      } catch (e) {
        this.isCommentAbsolute = false;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page {
  background-color: rgba(247, 248, 250, 1);
  position: relative;
  @media (max-width: 768px) {/* 移动端 */
    width: 100%;
    /* 预留底部按钮条的高度，避免内容被遮挡 */
    padding-bottom: calc(188 / 750 * 100vw);
  }
}

.fullscreen-loading {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.35);
}
.fullscreen-loading__spinner {
  width: 44px;
  height: 44px;
  border: 4px solid rgba(255, 255, 255, 0.35);
  border-top-color: rgba(255, 255, 255, 0.95);
  border-radius: 50%;
  animation: fullscreenSpin 0.9s linear infinite;
}
.fullscreen-loading__text {
  margin-top: 12px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.92);
  font-family: "FZLanTingHeiS-R-GB";
}
@keyframes fullscreenSpin {
  to { transform: rotate(360deg); }
}
.nav-bar {
  @media (min-width: 768px) {
  }
  @media (max-width: 768px) {
    .nav-title {
      display: none;
    }
  }
  padding: 2.7vw 0 1.4vw;
  .nav-title {
    font-family: 'FZLanTingHeiS-R-GB';
      
    font-size: calc(20 / 1920 * 100vw);
    line-height: calc(31 / 1920 * 100vw);
    font-weight: 500;
    color: #000;
    span {
      display: inline-block;
      color: #000;
      margin-left: calc(4 / 1920 * 100vw);
      margin-right: calc(4 / 1920 * 100vw);
    }
  }
}
.nav-bar-portrait {
  padding: calc(44 / 750 * 100vw) 0;
  img {
    height: calc(32 / 750 * 100vw);
  }
}
.container {
  
  min-height: 100vh;
  
  @media (min-width: 768px) {/* pc端 */
    padding: 78px 0 78px 0;
    // padding-left:calc(123 / 1920 * 100vw);
    // padding-right:calc(123 / 1920 * 100vw);
    width: calc(1665 / 1920 * 100vw);
    max-width: 1400px;
    margin: 0 auto;
  }
  @media (max-width: 768px) {/* 移动端 */
    width: 100%;
    padding: 60px calc(42 / 750 * 100vw) calc(0 / 750 * 100vw) calc(42 / 750 * 100vw);
  }
}
.content-part {
  display: flex;
}

.detail-part {
    @media (min-width: 768px) {/* pc端 */
    //   width: calc(1092 / 1920 * 100vw);
    
        width: 65.5%;
    }
    @media (max-width: 768px) {/* 移动端 */
        width: 100%;
    }
}

.welcome-img {
  @media (min-width: 768px) {/* pc端 */
    width: auto;
    height: calc(78 / 1920 * 100vw);
    max-height: 68px;
    margin: calc(73 / 1920 * 100vw) 0 calc(48 / 1920 * 100vw) 0;
  }
  @media (max-width: 768px) {/* 移动端 */

  }
}
.button-part {
  display: flex;
  justify-content: start;
  align-items: center;
  @media (min-width: 768px) {/* pc端 */
    gap: calc(13 / 1920 * 100vw);
    margin-bottom: calc(13 / 1920 * 100vw);
  }
  @media (max-width: 768px) {/* 移动端 */
    
  }
  img {/* 按钮图片 */
    width: auto;
    height: calc(48 / 1920 * 100vw);
    max-height: 38px;
    @media (min-width: 768px) {/* pc端 */
      width: auto;
      height: calc(48 / 1920 * 100vw);
      cursor: pointer;
    }
    @media (max-width: 768px) {/* 移动端 */
    }
  }
}
.comment-part {
    width: 100%;
    
  @media (min-width: 768px) {/* pc端 */
    background-color: #fff;
    position: relative;
  }
  @media (max-width: 768px) {/* 移动端 */
  }
}
::v-deep .el-textarea {
    @media (min-width: 768px) {/* pc端 */
        position: initial;
    }
    @media (max-width: 768px) {/* 移动端 */
    }
}
.moment-input {
  @media (min-width: 768px) {/* pc端 */
    width: 100%;
    ::v-deep .el-textarea__inner {
      width: 100%;
      height: calc(150 / 1920 * 100vw);
      max-height: 100px;
      border: 1px solid rgba(213, 213, 213, 1);
      resize: none;
    }
  }
  @media (max-width: 768px) {/* 移动端 */
  }
}
.moment-upload {
  .image-upload-wrapper {
    position: relative;
    @media (min-width: 768px) {/* pc端 */
      margin: 0 20px;
    }
    @media (max-width: 768px) {/* 移动端 */
    }
  }
  .image-upload-hidden {
    // Keep it mounted so we can trigger file picker, but don't display it
    height: 0;
    overflow: hidden;
    opacity: 0;
    pointer-events: none;
  }
  .moment-upload-row {
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 10px 0;
    .moment-upload-image {
      width: auto;
      cursor: pointer;
      @media (min-width: 768px) {/* pc端 */
        margin-left: 20px;
        height: calc(37 / 1920 * 100vw);
        max-height: 30px;
      }
      @media (max-width: 768px) {/* 移动端 */
      }
    }
    .moment-upload-tip {
      width: auto;
      @media (min-width: 768px) {/* pc端 */
        margin-left: 20px;
        height: calc(17 / 1920 * 100vw);
        max-height: 13px;
      }
      @media (max-width: 768px) {/* 移动端 */
      }
    }
  }
}
.submit-button-part {
    
    @media (min-width: 768px) {/* pc端 */
        width: 100%;
        margin-top: calc(13 / 1920 * 100vw);
        display: flex;
        justify-content: flex-end;
    }
    img {

        @media (min-width: 768px) {/* pc端 */
            
            width: auto;
            height: calc(45 / 1920 * 100vw);
            max-height: 36px;
            cursor: pointer;
        }
        
    }
}
.submit-button-part-detail {
    @media (min-width: 768px) {/* pc端 */
        margin-top: calc(20 / 1920 * 100vw);
    }
    @media (min-width: 1614px) {/* 1614px以上 */
        margin-top: 10px;
    }
}
.article-image {
    img {
        @media (min-width: 768px) {/* pc端 */
            width: 100%;
            aspect-ratio: 1092/614;
            object-fit: cover;
            object-position: center;
        }
        @media (max-width: 768px) {/* 移动端 */
            width: 100%;
            height: calc(373 / 750 * 100vw);
            aspect-ratio: 664/373;
            object-fit: cover;
            object-position: center;
            border-radius: calc(10 / 750 * 100vw);
            background-color: #f5f5f5; /* 占位背景色 */
        }
    }
    img {
        @media (min-width: 768px) {/* pc端 */
            border-radius: calc(10 / 1920 * 100vw);
        }
        @media (min-width: 1614px) {/* 1614px以上 */
            border-radius: 10px;
        }
        @media (max-width: 768px) {/* 移动端 */
            border-radius: calc(10 / 750 * 100vw);
        }
    }
}

.comment-total {
    color: rgba(0, 0, 0, 0.8);
    font-family: "FZLanTingHeiS-R-GB";
    line-height: 1;
    @media (min-width: 768px) {/* pc端 */
        font-size: calc(21 / 1920 * 100vw);
        margin-bottom: 1.8%;
        margin-left: 2%;
    }
    @media (min-width: 1614px) {/* 1614px以上 */
        font-size: 16px;
    }
    @media (max-width: 768px) {/* 移动端 */
        width: 100%;
        background-color: #fff;
        position: absolute;
        left: 0;
        text-align: center;
        font-size: calc(20 / 750 * 100vw);
        padding:calc(15 / 750 * 100vw) 0;
    }
}
.detail-container { 
    
    @media (min-width: 768px) {/* pc端 */
        width: 100%;
        padding: 3% 2%;
        margin-bottom: 2%;
        background-color: #fff;
    }
    @media (max-width: 768px) {/* 移动端 */
        margin-top: calc(80 / 750 * 100vw);
    }
}
.detail-container-portrait {
    @media (max-width: 768px) {/* 移动端 */
        margin-top: calc(20 / 750 * 100vw);
    }
}

.article-title {
    font-family: "FZLanTingHeiS-R-GB";
    @media (min-width: 768px) {/* pc端 */
        font-size: calc(38 / 1920 * 100vw);
        margin-bottom: 2%;
    }
    @media (min-width: 1614px) {/* 1614px以上 */
        font-size: 30px;
    }
    @media (max-width: 768px) {/* 移动端 */
        font-size: calc(45 / 750 * 100vw);
        margin: calc(87 / 750 * 100vw) 0 calc(58 / 750 * 100vw) 0;
    }
    
}
.moment-info {
    @media (min-width: 768px) {/* pc端 */
        margin-bottom: 2%;
    }
    @media (max-width: 768px) {/* 移动端 */
        margin-bottom: calc(30 / 750 * 100vw);
    }
}
.moment-info-portrait {
    @media (max-width: 768px) {/* 移动端 */
      margin-bottom: 0;
    }
}
.card-info {
    display: flex;
    align-items: center;
    justify-content: start;
    font-family: "FZLanTingHeiS-R-GB";
    .info-avatar {
        border-radius: 50%;
        @media (min-width: 768px) {/* pc端 */
            width: calc(54 / 1920 * 100vw);
            height: calc(54 / 1920 * 100vw);
            max-width: 45px;
            max-height: 45px;
            
        }
        @media (max-width: 768px) {/* 移动端 */
            width: calc(74 / 750 * 100vw);
            height: calc(74 / 750 * 100vw);
        }
    }
    .info-avatar-second {
        @media (max-width: 768px) {/* 移动端 */
            width: calc(54 / 750 * 100vw);
            height: calc(54 / 750 * 100vw);
        }
    }
    .info-text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        // align-items: space-between;
        
        
        @media (min-width: 768px) {/* pc端 */
            margin-left: calc(14 / 1920 * 100vw);
            height: calc(54 / 1920 * 100vw);
            max-height: 45px;
        }
        @media (min-width: 1614px) {/* 1614px以上 */
            margin-left: 10px;
        }
        @media (max-width: 768px) {/* 移动端 */
          margin-left: calc(20 / 750 * 100vw);
        }
    }
    .info-name {
        color: rgba(123, 124, 124, 1);
        @media (min-width: 768px) {/* pc端 */
            font-size: calc(21 / 1920 * 100vw);
        }
        @media (min-width: 1614px) {/* 1614px以上 */
            font-size: 16px;
        }
        @media (max-width: 768px) {/* 移动端 */
            font-size: calc(29 / 750 * 100vw);
        }
    }
    .info-time {
        color: rgba(170, 170, 170, 1);
        @media (min-width: 768px) {/* pc端 */
            font-size: calc(14 / 1920 * 100vw);
        }
        @media (min-width: 1614px) {/* 1614px以上 */
            font-size: 12px;
        }
        @media (max-width: 768px) {/* 移动端 */
            font-size: calc(18 / 750 * 100vw);
        }
    }
}
.article-content {
    // margin-top: 1%;
    font-family: "FZLanTingHeiS-R-GB";
    @media (min-width: 768px) {/* pc端 */
        font-size: calc(20 / 1920 * 100vw);
        line-height: calc(34 / 1920 * 100vw);
        margin-top: 2%
    }
    @media (min-width: 1614px) {/* 1614px以上 */
        font-size: 16px;
        line-height: 24px;
    }
    @media (max-width: 768px) {/* 移动端 */
        font-size: calc(29 / 750 * 100vw);
        line-height: calc(45 / 750 * 100vw);
        margin-top: calc(20 / 750 * 100vw);
    }
    ::v-deep p {
        font-family: "FZLanTingHeiS-R-GB";
        @media (min-width: 768px) {/* pc端 */
            font-size: calc(20 / 1920 * 100vw);
            line-height: calc(34 / 1920 * 100vw);
        }
        @media (min-width: 1614px) {/* 1614px以上 */
            font-size: 16px;
            line-height: 24px;
        }
        @media (max-width: 768px) {/* 移动端 */
            font-size: calc(29 / 750 * 100vw);
            line-height: calc(54 / 750 * 100vw);
        }
    }
    ::v-deep img {
        @media (min-width: 768px) {/* pc端 */
            max-width: 100%;
            // 文章图片宽度100%，显示全部内容
            width: 100%;
            height: auto;
            border-radius: calc(10 / 1920 * 100vw);
            margin: calc(20 / 1920 * 100vw) 0;
        }
        @media (min-width: 1614px) {/* 1614px以上 */
            border-radius: 10px;
            margin: 15px 0;
        }
        @media (max-width: 768px) {/* 移动端 */
            max-width: 100%;
            // 文章图片宽度100%，显示全部内容
            width: 100%;
            height: auto;
            border-radius: calc(10 / 750 * 100vw);
            margin: calc(20 / 750 * 100vw) 0;
        }
    }
   
}
.dynamic-image {
    img {
        @media (min-width: 768px) {/* pc端 */
            width: 100%;
            //动态图片按比例显示
            // aspect-ratio: 1038/564;
            // object-fit: cover;
            // object-position: center;
            margin-top: 2%; 
            border-radius: calc(10 / 1920 * 100vw);
        }
        @media (min-width: 1614px) {/* 1614px以上 */
            border-radius: 10px;
        }
        @media (max-width: 768px) {/* 移动端 */
            width: 100%;
            //动态图片按比例显示
            // height: calc(361 / 750 * 100vw);
            // aspect-ratio: 664/361;
            // object-fit: cover;
            // object-position: center;
            border-radius: calc(10 / 750 * 100vw);
            background-color: #f5f5f5; /* 占位背景色 */
            margin-top: 5.6vw;
        }
    }
}
.card-content {
    font-family: "FZLanTingHeiS-R-GB";
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    @media (min-width: 768px) {/* pc端 */
        font-size: calc(20 / 1920 * 100vw);
        margin: calc(20 / 1920 * 100vw) 0;
    }
    @media (min-width: 1614px) {/* 1614px以上 */
        font-size: 15px;
        margin: 15px 0;
    }
    @media (max-width: 768px) {/* 移动端 */
    }
}
.card-image {
    @media (min-width: 768px) {/* pc端 */
        width: 100%;
        aspect-ratio: 1038/570;
        max-height: 100%;
        object-fit: cover;
        object-position: center;
        border-radius: 8px;
    }
    @media (max-width: 768px) {/* 移动端 */
    }
}
.card-footer-detail {
    @media (min-width: 768px) {/* pc端 */
        margin: calc(15 / 1920 * 100vw) 0;
    }
    @media (min-width: 1614px) {/* 1614px以上 */
        margin: 10px 0;
    }
    // @media (max-width: 768px) {/* 移动端 */
    //     margin: calc(15 / 750 * 100vw) 0;
    // }
}
.card-footer-second {
  .card-footer-item {
        display: flex;
        cursor: pointer;
        color: rgba(0, 0, 0, 0.6);
        // @media (min-width: 768px) {/* pc端 */
        //     margin-left: calc(50 / 1920 * 100vw);
        //     margin-top: calc(15 / 1920 * 100vw);
        //     margin-bottom: calc(15 / 1920 * 100vw);
        // }
        // @media (min-width: 1614px) {/* 1614px以上 */
        //     margin-left: 40px;
        //     margin-top: 12px;
        //     margin-bottom: 12px;
        // }
        @media (max-width: 768px) {/* 移动端 */
            margin-left: calc(46 / 750 * 100vw);
            margin-top: calc(20 / 750 * 100vw) !important;
            margin-bottom: calc(20 / 750 * 100vw) !important;
        }
    }
}
.card-footer {
    display: flex;
    align-items: center;
    justify-content: end;
    .card-footer-item {
        position: relative;
        display: flex;
        cursor: pointer;
        color: rgba(0, 0, 0, 0.6);
        @media (min-width: 768px) {/* pc端 */
            margin-left: calc(50 / 1920 * 100vw);
            margin-top: calc(15 / 1920 * 100vw);
            margin-bottom: calc(15 / 1920 * 100vw);
        }
        @media (min-width: 1614px) {/* 1614px以上 */
            margin-left: 40px;
            margin-top: 12px;
            margin-bottom: 12px;
        }
        @media (max-width: 768px) {/* 移动端 */
            margin-left: calc(46 / 750 * 100vw);
            margin-top: calc(40 / 750 * 100vw);
            margin-bottom: calc(40 / 750 * 100vw);
        }
        img {
            width: auto;
            @media (min-width: 768px) {/* pc端 */
                width: auto;
                height: calc(34 / 1920 * 100vw);
                max-height: 27px;
            }
            @media (max-width: 768px) {/* 移动端 */
                height: calc(54 / 750 * 100vw);
            }
        }
        div {
            font-family: "FZLanTingHeiS-R-GB";
            display: flex;
            align-items: center;
            justify-content: center;
            @media (min-width: 768px) {/* pc端 */
                margin-top: calc(4 / 1920 * 100vw);
                font-size: calc(16 / 1920 * 100vw);
            }
            @media (min-width: 1614px) {/* 1614px以上 */
                margin-top: 3px;
                font-size: 14px;
            }
            @media (max-width: 768px) {/* 移动端 */
                font-size: calc(25 / 750 * 100vw);
                margin-top: calc(10 / 750 * 100vw);
            }
        }
    }
    .card-footer-item.is-loading {
        pointer-events: none;
    }
    .footer-loading-mask {
        position: absolute;
        inset: -6px -10px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.65);
        border-radius: 8px;
    }
    .footer-spinner {
        width: 18px;
        height: 18px;
        border: 2px solid rgba(0, 0, 0, 0.18);
        border-top-color: rgba(0, 0, 0, 0.55);
        border-radius: 50%;
        animation: footerSpin 0.8s linear infinite;
    }
    .first-comment-like {/* 一级评论 操作按钮间距紧凑 */
        @media (min-width: 768px) {/* pc端 */
            margin-left: calc(20 / 1920 * 100vw);
        }
        @media (min-width: 1614px) {/* 1614px以上 */
            margin-left: 16px;
        }
        @media (max-width: 768px) {/* 移动端 */
            margin-left: calc(37 / 750 * 100vw);
        }
    }
}
// 评论
.comment-reply-part {
    @media (min-width: 768px) {/* pc端 */
        background-color: rgba(248, 248, 250, 1);
        margin-left: calc((54 + 14) / 1920 * 100vw);
        padding: 2%;
    }
    @media (min-width: 1614px) {/* 1614px以上 */
        margin-left: 55px;
    }
    @media (max-width: 768px) {/* 移动端 */
    }
}
.comment-content {
    font-family: "FZLanTingHeiS-R-GB";
    @media (min-width: 768px) {/* pc端 */
        padding-left: calc((54 + 14) / 1920 * 100vw);
        font-size: calc(20 / 1920 * 100vw);
        line-height: calc(34 / 1920 * 100vw);
    }
    @media (min-width: 1614px) {/* 1614px以上 */
        padding-left: 55px;
        font-size: 16px;
        line-height: 24px;
    }
    @media (max-width: 768px) {/* 移动端 */
        font-size: calc(29 / 750 * 100vw);
        line-height: calc(45 / 750 * 100vw);
    } 
}
.first-comment-content { 
  @media (min-width: 768px) {/* pc端 */
    margin-top: calc(20 / 1920 * 100vw);
    width: 90%
  }
}
.second-comment-content {
  @media (min-width: 768px) {/* pc端 */
    width: 88.8%
  }
  @media (max-width: 768px) {/* 移动端 */
    padding-left: calc(74 / 750 * 100vw);
  }
}

.second-comment-list {
    @media (min-width: 768px) {/* pc端 */
        padding-left: calc(160 / 1920 * 100vw);
        
    }
    @media (min-width: 1614px) {/* 1614px以上 */
        padding-left: 130px;
    }
    @media (max-width: 768px) {/* 移动端 */
        padding-left: calc(74 / 750 * 100vw);
    }
}
.second-comment-list .comment-item {
    @media (min-width: 768px) {/* pc端 */
        margin-top: 2%;
    }
    @media (min-width: 1614px) {/* 1614px以上 */
        
    }
    @media (max-width: 768px) {/* 移动端 */
    }
}
.load-part-first {
    @media (max-width: 768px) {/* 移动端 */
        padding-top: calc(80 / 750 * 100vw);
    }
    @media (min-width: 768px){
      padding-top: calc(30 / 1920 * 100vw);
    }
}
.load-part-second {
    display: flex;
    align-items: start !important;
    justify-content: start !important;
    @media (min-width: 768px) {/* pc端 */
      padding-left: calc((54 + 14) / 1920 * 100vw);
      padding-bottom: calc(30 / 1920 * 100vw);
    }
    @media (min-width: 1614px) {/* 1614px以上 */
      padding-left: 55px;
      padding-bottom: 20px;
    }
    @media (max-width: 768px) {/* 移动端 */
      padding-left: calc(74 / 750 * 100vw);
      padding-bottom: calc(50 / 750 * 100vw);
    }
}

@keyframes footerSpin {
  to { transform: rotate(360deg); }
}
.load-part {
    display: flex;
    align-items: center;
    justify-content: center;
    .load-more-sentinel {
        width: 100%;
        height: 1px;
        pointer-events: none;
        flex-shrink: 0;
    }
    .loadmore {
        cursor: pointer;
    }
    .load-ing {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .circle {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        border: 2px solid rgba(0, 0, 0, 0.15);
        border-top-color: rgba(0, 0, 0, 0.55);
        box-sizing: border-box;
        animation: circle-rotate 0.9s linear infinite;
        margin-right: 6px;
    }
    img {
        @media (min-width: 768px) {/* pc端 */
            width: auto;
            height: calc(18 / 1920 * 100vw);
            max-height: 14px;
        }
        @media (max-width: 768px) {/* 移动端 */
            height: calc(26 / 750 * 100vw);
        }
    }
}

@keyframes circle-rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.mobile-comment-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99; /* mobile-comment-part 默认 1000，保证输入条仍可点 */
  background: rgba(0, 0, 0, 0.5);
}

.mobile-comment-part {
    display: block;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    padding: calc(27 / 750 * 100vw) calc(50 / 750 * 100vw);
    background-color: rgba(247, 248, 250, 1); /* 与页面背景一致，避免透明 */
    justify-content: space-between;

    &.mobile-comment-part--hide {
      // position: absolute;
      // bottom: 0;
      // left: 0;
      // right: 0;
    display: none;
  }
  ::v-deep .el-textarea__inner {
      width: 100%;
      max-height: 100px;
      border: none;
      resize: none;
      background-color: rgba(243, 243, 243, 1);
  }
  //placeholder
    ::v-deep .el-textarea__inner::placeholder {
        color: rgba(0, 0, 0, 0.5); 
    }
  
  .short-level-input {
    ::v-deep .el-textarea__inner {
      height: calc(87 / 750 * 100vw);
    }
    ::v-deep .el-textarea__inner::placeholder {
        padding-top: calc(15 / 750 * 100vw);
    }
  }
  .height-level-input {
    ::v-deep .el-textarea__inner {
      height: calc(157 / 750 * 100vw);
    }
  }
  .comment-submit {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    img {
        width: calc(167 / 750 * 100vw);
        height: calc(66 / 750 * 100vw);
        margin-top: calc(27 / 750 * 100vw)
    }
  }
}

.advertise-part {
  @media (min-width: 768px) {/* pc端 */
    // width: calc(538 / 1920 * 100vw);
    width: 32.5%;
    margin-left: 2%;
    // background-color: beige;
  }
  @media (max-width: 768px) {/* 移动端 */
  }
}
</style>